export default "__VITE_ASSET__DUd8mQdZ__"